import * as React from "react";
import { Button, Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { linksOf } from "../../services/cpln";
import { CloudAccount } from "../../schema/types/cloudaccount/entity";
import { FormItemDescription } from "../../components/antd/form/FormItemDescription";
import { Link } from "react-router-dom";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { FormItem } from "../../components/antd/form/FormItem";
import { CopyButtonWithApproval } from "../domain/create/copyButtonWithApproval";
import { BrowserServiceModal } from "../identity/create/browserServiceModal";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";

interface Props {
  cloudAccount: CloudAccount;
}
export const Summary: React.FC<Props> = ({ cloudAccount }) => {
  const selfLink = linksOf(cloudAccount).self!;

  const [isBrowsing, setIsBrowsing] = React.useState(false);

  function onBrowse() {
    setIsBrowsing(true);
  }

  const hasTagLinks =
    Object.entries(cloudAccount.tags || {}).filter(([_, value]) =>
      tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
    ).length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            <div className={`flex flex-wrap gap-x-32 gap-y-8 mt-4 mb-8`}>
              <div>
                <div className="text-sm">Cloud Provider</div>
                <FormItemValue>{cloudAccount.provider}</FormItemValue>
              </div>
              {cloudAccount.provider === "aws" ? (
                <div>
                  <div className="text-sm">Role ARN</div>
                  <FormItemValue className="inline mr-1">{(cloudAccount.data as any)?.roleArn}</FormItemValue>
                  <CopyButtonWithApproval value={(cloudAccount.data as any)?.roleArn} />
                </div>
              ) : null}
              {cloudAccount.provider === "gcp" ? (
                <div>
                  <div className="text-sm">Project ID</div>
                  <FormItemValue>{(cloudAccount.data as any)?.projectId}</FormItemValue>
                </div>
              ) : null}
              {cloudAccount.provider === "ngs" || cloudAccount.provider === "azure" ? (
                <div>
                  <div className="text-sm">Secret</div>
                  <Link to={`/console${(cloudAccount.data as any)?.secretLink}`} className={`color-link`}>
                    {(cloudAccount.data as any)?.secretLink?.split(`/`)[4] || "Not Found"}
                  </Link>
                </div>
              ) : null}
            </div>
            {cloudAccount.provider === "ngs" ? null : (
              <FormItem lastItem>
                <FormLabel>Browser Service</FormLabel>
                <FormItemDescription>
                  Check the resources with this cloud account to see if it is correctly configured.
                </FormItemDescription>
                <Button htmlType={`button`} className="mt-2" size={"small"} type={"primary"} onClick={onBrowse}>
                  Browse
                </Button>
              </FormItem>
            )}
            {hasTagLinks ? (
              <TagLinksTable
                tableId="cloudaccount-info-tag-links"
                tags={Object.entries(cloudAccount.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
      <BrowserServiceModal
        open={isBrowsing}
        title={"Browse Resources"}
        cloudaccountLink={selfLink}
        onClose={() => {
          setIsBrowsing(false);
        }}
        selectionType={"none"}
      />
    </>
  );
};
